// extracted by mini-css-extract-plugin
var _1 = "name-Ch2ec";
var _2 = "trust-NI7wX";
export { _1 as "name", _2 as "trust" }
